import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { KENDO_DATEINPUTS, KENDO_DATEPICKER } from '@progress/kendo-angular-dateinputs';
import { KENDO_ICONS } from '@progress/kendo-angular-icons';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { environment } from '../../../../environments/environment.prod';

@Component({
    selector: 'gd-datepicker',
    template: `
    <div [formGroup]="form" class="spacing">
      <div class="date-input-container">
        <kendo-datepicker
          [(value)]="field.value"
          [id]="field.name"
          (valueChange)="selectionChanger($event)"
          [formControlName]="field.name"
        >
        </kendo-datepicker>
        <div
          style="white-space: nowrap; padding-left:5px; flex: 0 0 auto;"
          *ngIf="field.name === 'DateSigned' && ageAtTransaction"
        >
          - {{ ageAtTransaction }} yo
        </div>
      </div>
      <span
        *ngIf="field.dategreater3years === true"
        style="color:red;font-size:11px; padding-left:5px;"
      >
        Warning: You have entered a Future Date!
      </span>
      <span
        *ngIf="
          field.accountformdateisgreater === true ||
          (validinfo && field.name === 'DateOfNewAccountForm')
        "
        style="color:red;font-size:11px; padding-left:5px;"
      >
        Warning: Account Date is greater than 3 years from Date Received.</span
      >
      <span
        *ngIf="
          field.name === 'DateReceived' &&
          DaterecievedValue === true &&
          validinfoDateSigned === false
        "
        style="color:red;font-size:11px; padding-left:5px;"
      >
        Warning: You have entered a Future Date!</span
      >
      <span
        *ngIf="
          field.name === 'DateOfNewAccountForm' &&
          Dateaccountformvalue === true &&
          validinfoDateSigned === false
        "
        style="color:red;font-size:11px; padding-left:5px;"
      >
        Warning: You have entered a Future Date!</span
      >
    </div>
  `,
    styles: [
        `
      .date-input-container {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .date-input-container kendo-datepicker {
        flex: 0 0 auto;
        width: 220px;
      }
    `,
    ],
    imports: [
      CommonModule,
        FormsModule,
        ReactiveFormsModule,
        KENDO_LABEL, KENDO_DATEINPUTS, KENDO_ICONS, KENDO_DATEPICKER,
        NgIf,
    ]
})
export class DatePickerComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  public validinfo: boolean
  public validinfoDateSigned = false
  public value = new Date()
  public DaterecievedValue = false
  public Dateaccountformvalue = false
  public hidetext = 'show'
  public ageAtTransaction: string
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.validinfo = false
    this.hidetext = 'show'
  }

  ngOnInit() {
    if (this.field.name === 'DateSigned') {
      const clientDob = this.form.get('clientdob')?.value ?? ''
      this.ageAtTransaction =
        this.field.value != null && clientDob != ''
          ? this.calculateAge(clientDob, this.field.value)
          : ''
    }
  }

  selectionChanger(event) {
    if (
      this.form.value.DateReceived !== '' &&
      this.form.value.DateOfNewAccountForm !== ''
    ) {
      const newaccount = this.form.value.DateOfNewAccountForm
      const recievedate = this.form.value.DateReceived
      const comparedates = newaccount.getYear() - recievedate.getYear()
      if (comparedates > 3) {
        this.validinfo = true
      } else {
        this.validinfo = false
        this.field.accountformdateisgreater = false
      }
    }
    const comparedatesDateSigned3 = new Date()
    const currentDateSigned = this.form.value.DateReceived
    if (currentDateSigned > comparedatesDateSigned3) {
      this.DaterecievedValue = true
    } else {
      this.DaterecievedValue = false
    }
    const compareDateOfNewAccountFormcurrent = new Date()
    const currentDateOfNewAccountForm = this.form.value.DateOfNewAccountForm
    if (currentDateOfNewAccountForm > compareDateOfNewAccountFormcurrent) {
      this.Dateaccountformvalue = true
    } else {
      this.Dateaccountformvalue = false
    }
    const newaccountDateSigned = this.form.value.DateSigned
    const comparedatesDateSigned = new Date()
    const comparedatesf = newaccountDateSigned > comparedatesDateSigned
    if (comparedatesf) {
      this.validinfoDateSigned = true
      this.field.dategreater3years = true
    } else {
      this.validinfoDateSigned = false
      this.field.dategreater3years = false
    }
    if (event.key === 'PENDING ALERT') {
      this.form.get('AlertRepText').setValue(environment.alertpendingtxt)
    }
    this.cdr.detectChanges()
  }
  selectionChangerblurred(event) {
    if (
      this.form.value.DateReceived !== '' &&
      this.form.value.DateOfNewAccountForm !== ''
    ) {
      const newaccount = this.form.value.DateOfNewAccountForm
      const recievedate = this.form.value.DateReceived
      const comparedates = newaccount.getYear() - recievedate.getYear()
      if (comparedates > 3) {
        this.validinfo = true
      } else {
        this.validinfo = false
        this.field.accountformdateisgreater = false
      }
    }
    const newaccountDateSigned = this.form.value.DateSigned
    const comparedatesDateSigned = new Date()
    const comparedates =
      newaccountDateSigned.getDay() > comparedatesDateSigned.getDay()
    if (comparedates) {
      this.validinfoDateSigned = true
      this.field.dategreater3years = true
    } else {
      this.validinfoDateSigned = false
      this.field.dategreater3years = false
    }
    if (event.key === 'PENDING ALERT') {
      this.form.get('AlertRepText').setValue(environment.alertpendingtxt)
    }
    this.cdr.detectChanges()
  }

  private calculateAge(
    fromDate: string,
    toDate: string = new Date().toString(),
  ): string {
    const from = new Date(fromDate)
    const to = new Date(toDate ?? new Date().toString())

    let yearsDifference = to.getFullYear() - from.getFullYear()

    if (
      to.getMonth() < from.getMonth() ||
      (to.getMonth() === from.getMonth() && to.getDate() < from.getDate())
    ) {
      yearsDifference--
    }

    return yearsDifference.toString()
  }
}
